<div class="badge__wrapper">Recomendado</div>
